import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { DictionariesCompanyModel } from "../../../viewModels/Dictionaries/DictionariesCompanyModel";
import SortObject from "../../../types/SortObject";

const initialState: {
  loading: boolean;
  loadingData: boolean;
  companies: Array<DictionariesCompanyModel>;
  total: number;
  pageSize: number;
  page: number;

  sort: SortObject;

  searchFilterValue: string;
} = {
  loading: true,
  loadingData: true,
  companies: undefined!,
  total: undefined!,
  pageSize: 10,
  page: 1,

  sort: undefined!,

  searchFilterValue: "",
};

const dictionariesCompaniesSlice = createSlice({
  name: "dictionariesCompanies",
  initialState,
  reducers: {
    loadCompanies(state) {
      state.loadingData = true;
    },
    loadCompaniesSuccess(state, action: PayloadAction<{ companies: Array<DictionariesCompanyModel>; total: number }>) {
      const { companies, total } = action.payload;
      state.loading = false;
      state.loadingData = false;
      state.companies = companies;
      state.total = total;
    },
    loadCompaniesError(state) {
      state.loadingData = false;
    },

    changeTable(state, action: PayloadAction<{ page: number; pageSize: number; sort: SortObject }>) {
      state.page = action.payload.page;
      state.pageSize = action.payload.pageSize;
      state.sort = action.payload.sort;
      state.loadingData = true;
    },

    changeSearchFilterValue(state, action: PayloadAction<string>) {
      state.searchFilterValue = action.payload;
    },
    search(state) {
      state.loadingData = true;
      state.page = 1;
    },
  },
});

export default dictionariesCompaniesSlice;
